//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../../funcionales/FormContent";
import MarcoModal from "../../funcionales/MarcoModal";
import FormHeader from "../../funcionales/FormHeader";
import TextButton from "../../buttons/TextButton";
import Loading from "../../../routes/Loading";
//------------------------------------------------------ funciones
import {
  capitalizarTexto,
  cargarSelects,
} from "../../../functions/dataFunctions";
import { submitMovimientoTrafico } from "../data/Submits";
import { eventos } from "../data/FormContent";
//------------------------------------------------------ estilos
import "../css/Forms.css";

const FormMovimientoTrafico = ({
  elemento = null,
  type = "trafico",
  onGuardar,
  onClose,
}) => {
  const campos = eventos[type];
  // El nombre interno del tipo no es un título: «traficoSatelital» arriba
  // del formulario se leía como un error de la pantalla.
  const titulo =
    { traficoSatelital: "Satelital", trafico: "Tráfico" }[type] ||
    capitalizarTexto(type);
  const subtitulo = "Registro de eventos";

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({});
  const [formData, setFormData] = useState({
    area: type || "satelital",
    tipo: elemento?.tipo || "",
    operador: elemento?.operador || "",
    persona: elemento?.persona || "",
    tractor: elemento?.tractor || "",
    furgon: elemento?.furgon || [],
    personaRelacionada: elemento?.personaRelacionada || [],
    tractorRelacionado: elemento?.tractorRelacionado || [],
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects();
      setListas(data);
      setLoading(false);
    };

    cargarDatos();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitMovimientoTrafico(
      elemento,
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      true, // bandera para satelital
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="doble-form">
          <div className="doble-form-content">
            <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />
            <div className="doble-form-modal">
              <FormContent
                elemento={elemento}
                campos={campos}
                opciones={listas}
                data={formData}
                setData={setFormData}
                isDouble={true}
              />
            </div>
            <div className="form-buttons">
              <TextButton
                text={"Guardar"}
                type={"button"}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormMovimientoTrafico;
